export default "__VITE_ASSET__22992719__"